"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_STATUS_SUCCESS = exports.VALIDATE_STATUS_ERROR = exports.VALIDATE_ICONS = exports.TOP = exports.TEXT_TYPE = exports.TEXT_COLOR = exports.SCROLL_SPACE = exports.RECENT_SEARCH_KEY = exports.PLACEHOLDER = exports.ORIGIN_ID = exports.OPTIONS_TOP = exports.OPTIONS_CONDITIONS = exports.MAX_HEIGHT = exports.LOCALE = exports.KEY_CODE = exports.INPUT_VARIANT = exports.ICON_TYPE = exports.ICON_STYLE = exports.HIGHTLIGHT_COLOR = exports.DESTI_ID = exports.DEFAULT_ICON_COLOR = exports.DEFAULT_ICON = exports.CITY_CODE = exports.CATEGORIES = exports.ALL_AIRPORTS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _VALIDATE_ICONS;

var DEFAULT_ICON_COLOR = 'greyDark';
exports.DEFAULT_ICON_COLOR = DEFAULT_ICON_COLOR;
var DEFAULT_ICON = 'LocationOnIcon';
exports.DEFAULT_ICON = DEFAULT_ICON;
var INPUT_VARIANT = {
  disabled: 'disabled',
  error: 'error',
  focused: 'focused'
};
exports.INPUT_VARIANT = INPUT_VARIANT;
var VALIDATE_STATUS_SUCCESS = 'success';
exports.VALIDATE_STATUS_SUCCESS = VALIDATE_STATUS_SUCCESS;
var VALIDATE_STATUS_ERROR = 'error';
exports.VALIDATE_STATUS_ERROR = VALIDATE_STATUS_ERROR;
var VALIDATE_ICONS = (_VALIDATE_ICONS = {}, (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_SUCCESS, {
  name: 'CheckIcon',
  color: 'tertiary'
}), (0, _defineProperty2.default)(_VALIDATE_ICONS, VALIDATE_STATUS_ERROR, {
  name: 'ErrorIcon',
  color: 'orange'
}), _VALIDATE_ICONS);
exports.VALIDATE_ICONS = VALIDATE_ICONS;
var LOCALE = {
  noResultLabel: 'There is no result for {0}',
  loadOptions: 'Options are loading',
  recentSearch: 'Recent Searches',
  noRightKeywordLabel: 'Please enter right type of keyword',
  clear: 'Clear',
  searchFor: 'Search for'
};
exports.LOCALE = LOCALE;
var HIGHTLIGHT_COLOR = 'rgba(75, 79, 166, 0.2)';
exports.HIGHTLIGHT_COLOR = HIGHTLIGHT_COLOR;
var MAX_HEIGHT = 252;
exports.MAX_HEIGHT = MAX_HEIGHT;
var SCROLL_SPACE = 56;
exports.SCROLL_SPACE = SCROLL_SPACE;
var KEY_CODE = {
  ENTER: 13
};
exports.KEY_CODE = KEY_CODE;
var CATEGORIES = {
  hotel: 'Hotels SA|hotelsearchwidget',
  snap: 'SNAP|snapsearchwidget',
  snapHotelSearchListing: 'SNAP|hotelsearchlisting',
  hotelSearchListing: 'Hotels SA|hotelsearchlisting'
};
exports.CATEGORIES = CATEGORIES;
var CITY_CODE = 'C';
exports.CITY_CODE = CITY_CODE;
var ALL_AIRPORTS = '(All airports)';
exports.ALL_AIRPORTS = ALL_AIRPORTS;
var ICON_STYLE = {
  SIZE: 'titleNormal',
  COLOR_DEFAULT: 'greyDark',
  COLOR_TERTIARY: 'tertiary'
};
exports.ICON_STYLE = ICON_STYLE;
var ICON_TYPE = {
  CHECK: 'CheckIcon',
  EX_LESS: 'ExpandLessIcon',
  EX_MORE: 'ExpandMoreIcon',
  CANCEL: 'CancelIcon',
  BACK: 'ArrowBackIos'
};
exports.ICON_TYPE = ICON_TYPE;
var RECENT_SEARCH_KEY = 'recent-search';
exports.RECENT_SEARCH_KEY = RECENT_SEARCH_KEY;
var DESTI_ID = 'originDestionation';
exports.DESTI_ID = DESTI_ID;
var ORIGIN_ID = 'origin';
exports.ORIGIN_ID = ORIGIN_ID;
var TEXT_COLOR = {
  GREY: 'greyMedium',
  NEUTRAL: 'neutral'
};
exports.TEXT_COLOR = TEXT_COLOR;
var TEXT_TYPE = {
  DEFAULT: 'default',
  SMALL: 'small'
};
exports.TEXT_TYPE = TEXT_TYPE;
var PLACEHOLDER = {
  ORIGIN: 'Flying from',
  DESTINATION: 'Going to'
};
exports.PLACEHOLDER = PLACEHOLDER;
var TOP = 'top';
exports.TOP = TOP;
var OPTIONS_TOP = {
  cityLevel: {
    top: 'top: 68px;',
    bottom: 'bottom: 69px;',
    topShow: 'top: 65px;'
  },
  default: {
    top: 'top: 59px;',
    bottom: 'bottom: 60px;',
    topShow: 'top: 56px;'
  }
};
exports.OPTIONS_TOP = OPTIONS_TOP;
var OPTIONS_CONDITIONS = {
  CITY_LEVEL: 'cityLevel',
  DEFAULT: 'default'
};
exports.OPTIONS_CONDITIONS = OPTIONS_CONDITIONS;